import { TRule } from 'utils'
import * as Yup from 'yup'

export const toOriginalAttributeName = (key: string): string => {
  return key
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
export const getEditableAttributeSchema = (
  validationRules: Record<string, TRule>
) =>
  Yup.object().shape({
    attributes: Yup.lazy((obj) =>
      Yup.object().shape(
        Object.keys(obj || {}).reduce((acc, key) => {
          const originalKey = toOriginalAttributeName(key)
          const rule = validationRules[originalKey]
          acc[key] = Yup.object().shape({
            value: Yup.string().test(
              'is-numeric',
              'Must be number',
              function (value) {
                if (value === undefined || value === null || value === '') {
                  return true
                }

                // Check if the value is a valid number
                const num = Number(value)
                if (isNaN(num)) {
                  return this.createError({
                    message: 'Must be number',
                    path: this.path,
                  })
                }

                if (rule) {
                  if (rule.hardMin !== undefined && num < rule.hardMin) {
                    return this.createError({
                      message: `Must be at least ${rule.hardMin}`,
                      path: this.path,
                    })
                  }

                  if (rule.hardMax !== undefined && num > rule.hardMax) {
                    return this.createError({
                      message: `Must be at most ${rule.hardMax}`,
                      path: this.path,
                    })
                  }
                }

                return true
              }
            ),
          })
          return acc
        }, {})
      )
    ),
  })
